<div class="header row">
    <div class="col-12">
        <h2><strong>Fornitori</strong></h2>
        <div *ngIf="false" class="breadcrumb-wrapper hidden-xs">
            <ol class="breadcrumb">
                <li class="active">Fornitori</li>
            </ol>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12" style="margin-bottom: 80px;">
        <div class="panel">
            <div class="panel-content">
                <div *ngIf="suppliers!.length > 0; else suppliersEmpty">
                    <ng-container *ngIf="(suppliers
                          | advancedSearchFilter: advancedFields: advancedState
                          | supplierGlobalSearchFilter: globalSearchFilterValue
                          | supplierIdFilter: idFilterValue
                          | supplierNameFilter: nameFilterValue
                          | supplierCfFilter: cfFilterValue
                          | supplierEmailFilter: emailFilterValue) as filteredSuppliers">
                        <app-advanced-search [fields]="advancedFields"
                                             [state]="advancedState"
                                             (stateChange)="onAdvancedStateChange($event)"></app-advanced-search>

                        <div class="dashboard-toolbar">
                            <div class="toolbar-left">
                                <label for="items-per-page">Mostra</label>
                                <input [(ngModel)]="paginationConfig.itemsPerPage"
                                       (change)="paginationConfig.currentPage = 1"
                                       class="form-control input-sm form-white items-per-page-input"
                                       id="items-per-page"
                                       name="items-per-page"
                                       type="number">
                                <span class="results-count">
                                    di {{ filteredSuppliers.length }}
                                    {{ filteredSuppliers.length === 1 ? 'fornitore' : 'fornitori' }}
                                </span>
                                <button *ngIf="hasActiveFilters()"
                                        type="button"
                                        class="btn btn-link btn-sm clear-filters-link"
                                        (click)="clearFilters()">
                                    Pulisci filtri
                                </button>
                            </div>

                            <div class="toolbar-right">
                                <button type="button"
                                        class="btn btn-sm btn-secondary export-csv-btn"
                                        [disabled]="filteredSuppliers.length === 0"
                                        (click)="exportCsv(filteredSuppliers)"
                                        title="Esporta in CSV i fornitori filtrati">
                                    <i class="fa fa-download" style="margin-right: 7px;"></i>CSV
                                </button>
                                <a (click)="openCreateSupplierModal()"
                                   class="edit btn btn-sm btn-primary">
                                    <i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Fornitore
                                </a>
                            </div>
                        </div>

                        <div class="row mobile-search-row">
                            <div class="col-xs-12">
                                <div class="form-group prepend-icon">
                                    <input [(ngModel)]="globalSearchFilterValue"
                                           (ngModelChange)="onFilterChange()"
                                           type="text"
                                           class="form-control form-white"
                                           id="mobile-global-search"
                                           name="mobile-global-search"
                                           placeholder="Cerca ID, nome, codice fiscale, email...">
                                    <i class="icon-magnifier"></i>
                                </div>
                            </div>
                        </div>

                        <div class="table-container table-scroll">
                            <table class="table table-hover table-supplier" [appStableColumns]="columnLayoutToken">
                                <thead>
                                <tr class="column-titles">
                                    <th class="col-id">ID Fornitore</th>
                                    <th class="col-flex">Nome</th>
                                    <th>Codice Fiscale</th>
                                    <th>Email</th>
                                    <th class="text-right col-sticky col-sticky-actions">Azioni</th>
                                </tr>
                                <tr class="column-filters hidden-xs hidden-sm">
                                    <th class="col-id">
                                        <input [(ngModel)]="idFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="ID"
                                               aria-label="Filtra per ID fornitore">
                                    </th>
                                    <th class="col-flex">
                                        <input [(ngModel)]="nameFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Nome"
                                               aria-label="Filtra per nome">
                                    </th>
                                    <th>
                                        <input [(ngModel)]="cfFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Codice fiscale"
                                               aria-label="Filtra per codice fiscale">
                                    </th>
                                    <th>
                                        <input [(ngModel)]="emailFilterValue"
                                               (ngModelChange)="onFilterChange()"
                                               type="text"
                                               class="form-control form-white column-filter-control"
                                               placeholder="Email"
                                               aria-label="Filtra per email">
                                    </th>
                                    <th class="col-sticky col-sticky-actions"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr *ngIf="filteredSuppliers.length === 0">
                                    <td colspan="5" class="filtered-empty-state">
                                        <div class="filtered-empty-pin">
                                            <p>Nessun risultato con i filtri attuali.</p>
                                            <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">Pulisci filtri</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr *ngFor="let supplier of filteredSuppliers | paginate: paginationConfig">
                                    <td class="col-id" (click)="goToSupplierDetail(supplier.IDSupplier)">{{ supplier.IDSupplier }}</td>
                                    <td (click)="goToSupplierDetail(supplier.IDSupplier)">{{ supplier.Name }}</td>
                                    <td (click)="goToSupplierDetail(supplier.IDSupplier)">{{ supplier.CF }}</td>
                                    <td class="col-email" (click)="goToSupplierDetail(supplier.IDSupplier)">
                                        <div *ngIf="getEmails(supplier.Email).length > 0; else noSupplierEmail" class="supplier-email-list">
                                            <span *ngFor="let email of getEmails(supplier.Email)" class="supplier-email-badge">
                                                <i class="fa fa-envelope-o supplier-email-badge-icon" aria-hidden="true"></i>
                                                <span class="supplier-email-badge-text">{{ email }}</span>
                                            </span>
                                        </div>
                                        <ng-template #noSupplierEmail>
                                            <span class="supplier-email-empty">—</span>
                                        </ng-template>
                                    </td>

                                    <td class="text-right col-sticky col-sticky-actions">
                                        <div ngbDropdown
                                             [autoClose]="'outside'"
                                             container="body"
                                             placement="bottom-right"
                                             class="btn-group">
                                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle aria-haspopup="true" aria-expanded="false">
                                                Azioni
                                            </button>
                                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right row-actions-menu">
                                                <a [routerLink]="['/fornitori/modifica/' + supplier.IDSupplier]" class="dropdown-item" type="button"><i class="fa fa-pencil"></i>Modifica</a>
                                                <button (click)="openDeleteSupplierModal(supplier)" class="dropdown-item" type="button"><i class="fa fa-trash-o"></i>Elimina</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <pagination-controls *ngIf="filteredSuppliers.length > 0"
                                             (pageChange)="pageChanged($event)"
                                             [autoHide]="paginationParams.autoHide"
                                             [maxSize]="paginationParams.maxSize"
                                             [responsive]="paginationParams.responsive"
                                             [previousLabel]="paginationLabels.previousLabel"
                                             [nextLabel]="paginationLabels.nextLabel"
                                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                        ></pagination-controls>
                    </ng-container>
                </div>
                <ng-template #suppliersEmpty>
                    <div>
                        <div class="row">
                            <div class="col-md-3 col-md-offset-9 col-xs-12" style="text-align: right;">
                                <a (click)="openCreateSupplierModal()" class="edit btn btn-sm btn-primary"><i class="fa fa-plus" style="margin-right: 7px;"></i>Crea Nuovo Fornitore</a>
                            </div>
                        </div>
                        <div style="height: 200px; text-align: center; padding-top: 85px;">
                            Nessun fornitore trovato.
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
